import {
  PRODUCT_CODE_DAVID_JONES_PREMIERE,
  PRODUCT_CODE_DAVID_JONES_PRESTIGE,
  PRODUCT_CODE_GO,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
  PRODUCTS,
  PRODUCT_CODE_AU_GEM,
  PRODUCT_CODE_AFS,
  PRODUCT_CODE_NZ_GEM,
  PRODUCT_DAVID_JONES,
  PRODUCT_CODE_LOW_RATE,
} from '_config';

export const CAMPAIGN_BANNER = 'campaignBanner';
export const ANNUAL_FEE = 'annualFee';

const defaultMaintenanceMessage = 'We will be back online as soon as possible. Thank you for your patience.';

const productCodes = Object.values(PRODUCTS).flatMap(countryProducts => Object.keys(countryProducts));

const defaultMaintenanceMessages = productCodes.reduce((acc, code) => {
  acc[code] = defaultMaintenanceMessage;
  return acc;
}, {});

const defaultOfferTypeMapping = {
  BALANCE_TRANSFER: 'Balance Transfer offer',
  EONX_REWARD: 'Latitude Rewards offer',
  CREDIT_BACK: 'Credit Back Offer',
  FEE_WAIVER: 'Fee Waiver Offer',
};

/**
 * defaultPromoCode is an object where each key is a product code string, and the value is either:
 *   - a string (promo code), or
 *   - an object with the following shape:
 *       {
 *         channels: {
 *           [channel name]: promo code
 *         }
 *       }
 */
// cspell:disable
const defaultPromoCode = {
  [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: 'DJGAOTEST',
  [PRODUCT_CODE_DAVID_JONES_PREMIERE]: '123',
  [PRODUCT_CODE_AU_GEM]: {
    channels: {
      DIRECT: '8QJML9QQ',
      APPLY_AND_SHOP: '9ZPBZK3G',
      EXTERNAL_QR: '9ZPBZK3G',
      INSTORE: '9ZPBZK3G',
      ONLINE: '9ZPBZK3G',
    },
  },
  [PRODUCT_CODE_GO]: {
    channels: {
      DIRECT: 'CSLE7FD9',
      APPLY_AND_SHOP: '8RND3HWJ',
      EXTERNAL_QR: '8RND3HWJ',
      INSTORE: '8RND3HWJ',
      ONLINE: '8RND3HWJ',
    },
  },
};
// cspell:enable

const defaultDjCampaignBanner = {
  [PRODUCT_CODE_DAVID_JONES_PREMIERE]: {
    title:
      'Apply for a David Jones credit card and, if approved, you could WIN an AO26 Finals Package thanks to Mastercard. Minimum spend and T&Cs apply. Offer ends 28 December 2025.',
    content: '{{tncLink}}', // placeholder for link replacement
    tncLink: 'https://cloud.cards.davidjones.latitudefinancial.com.au/win26',
    tncLinkText: 'Learn how to activate your offer.',
  },
  [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: {
    title:
      'Apply for a David Jones credit card and, if approved, you could WIN an AO26 Finals Package thanks to Mastercard. Minimum spend and T&Cs apply. Offer ends 28 December 2025.',
    content: '{{tncLink}}', // placeholder for link replacement
    tncLink: 'https://cloud.cards.davidjones.latitudefinancial.com.au/win26',
    tncLinkText: 'Learn how to activate your offer.',
  },
};

// Default values only, updated values are coming from LaunchDarkly
const defaultPremiereRatesAndFees = {
  purchaseAnnualRate: 23.99,
  cashAnnualRate: 24.99,
  annualFee: 149,
  additionalCardHolderFee: 24,
  lateFee: 35.0,
  paperStatementFee: 3.0,
  ausPostHandlingFee: 3.95,
  replacementCardFee: 0.0,
  minimumMonthlyPaymentAmount: 30,
  minimumRepaymentRate: 2.75,
  interestFreePeriod: 44,
  annualFeeWaiverSpendThresholds: 24000,
};

// Default values only, updated values are coming from LaunchDarkly
const defaultPrestigeRatesAndFees = {
  purchaseAnnualRate: 23.99,
  cashAnnualRate: 24.99,
  annualFee: 345,
  additionalCardHolderFee: 'Not Applicable',
  lateFee: 35.0,
  paperStatementFee: 3.0,
  ausPostHandlingFee: 3.95,
  replacementCardFee: 0.0,
  minimumMonthlyPaymentAmount: 30,
  minimumRepaymentRate: 2.75,
  interestFreePeriod: 44,
  annualFeeWaiverSpendThresholds: 36000,
};

// Default values only, updated values are coming from LaunchDarkly
const defaultAu28DRatesAndFees = {
  purchaseAnnualRate: 27.99,
  cashAnnualRate: 29.99,
  annualFee: 0.0,
  annualReward: 120,
  additionalCardHolderFee: 0.0,
  lateFee: 45.0,
  paperStatementFee: 5,
  ausPostHandlingFee: 3.95,
  onlinePaymentHandlingFee: 1.95,
  replacementCardFee: 0.0,
  cashAdvanceFeePercentagePerTransaction: 3.5,
  cashAdvanceFeeFixed: 4,
  monthlyFee: 0,
  minimumRepaymentRate: 2.5,
};

// Default values only, updated values are coming from LaunchDarkly
const defaultGoRatesAndFees = {
  purchaseAnnualRate: 27.99,
  cashAnnualRate: 29.99,
  expiredPromotionalPurchaseRate: 29.99,
  closingBalance: 10,
  cashAdvanceFeeFixed: 4,
  cashAdvanceFeePercentagePerTransaction: 3.5,
  annualFee: 0.0,
  additionalCardHolderFee: 0.0,
  lateFee: 45.0,
  paperStatementFee: 5,
  ausPostHandlingFee: 3.95,
  onlinePaymentHandlingFee: 1.95,
  balanceTransferringFee: 3,
  replacementCardFee: 0.0,
  monthlyFee: 10.95,
  establishmentFee: 0,
  internationalCashAccessRate: 3,
  internationalCashAccessFee: 3,
  internationalCashAccessAdditionalFee: 4,
  internationalCounterTransactionFee: 5,
  internationalTransactionFee: 3,
  adjustedClosingBalance: 30,
  minimumRepaymentRate: 2.75,
};

const defaultAuGemRatesAndFees = {
  purchaseAnnualRate: 27.99,
  cashAnnualRate: 29.99,
  expiredPromotionalPurchaseRate: 29.99,
  maximumPurchase1: 249.99,
  maximumPurchase2: 250.0,
  minimumRepaymentRate: 2.75,
  adjustedClosingBalance: 25,
  minimumRepaymentBalance: 5,
  closingBalance: 10,
  cashAdvanceFeeFixed: 4,
  cashAdvanceFeePercentagePerTransaction: 3.5,
  internationalTransactionRate: 3,
  annualFee: 0.0,
  additionalCardHolderFee: 0.0,
  lateFee: 45.0,
  paperStatementFee: 5,
  ausPostHandlingFee: 3.95,
  onlinePaymentHandlingFee: 1.95,
  balanceTransferringFee: 3,
  replacementCardFee: 0.0,
  monthlyFee: 10.95,
  interestRate: 0,
};

const defaultAfsRatesAndFees = {
  purchaseAnnualRate: 25.9,
  cashAnnualRate: 25.9,
  cashAdvanceFeeFixed: 4,
  cashAdvanceFeePercentagePerTransaction: 3.5,
  annualFee: 0.0,
  lateFee: 45.0,
  paperStatementFee: 5,
  ausPostHandlingFee: 3.95,
  onlinePaymentHandlingFee: 1.95,
  replacementCardFee: 0.0,
  monthlyFee: 5.95,
  establishmentFee: 0,
  eftposWithDrawalFee: 0.85,
  counterAdvanceWithDrawalFee: 5,
  counterPaymentWithDrawalFee: 1.85,
  expiredPromotionalPurchaseRate: 25.9,
};

const defaultLowRateRatesAndFees = {
  purchaseAnnualRate: 13.99,
  cashAnnualRate: 29.99,
  annualFee: 69,
  lateFee: 45.0,
  paperStatementFee: 5,
  ausPostHandlingFee: 3.95,
  onlinePaymentHandlingFee: 1.95,
  cashAdvanceFeePercentagePerTransaction: 3.5,
  cashAdvanceFeeFixed: 4,
  maximumCreditBalanceProcessingFee: 19.99,
  maximumBalanceTransferFeeRate: 3,
  internationalTransactionFee: 3,
  minimumMonthlyPaymentAmount: 25,
  minimumMonthlyPaymentRate: 2.75, // compatible to financial table usage
  minimumRepaymentRate: 2.75,
  rewardRate: 3,
  internationalTransactionFeeRate: 3,
  internationalATMWithdrawFee: 4,
  internationalCounterWithdrawFee: 5,
};

export const defaultNzRatesAndFees = {
  lateFee: 15,
  purchaseAnnualRate: 28.99,
  additionalCardHolderFee: 0,
  paperStatementFee: 1,
  replacementCardFee: 5,
  annualFee: 55,
  establishmentFee: 55,
  cashAnnualRate: 29.95,
  nzPostHandlingFee: 2.7,
  internationalTransactionFee: 2,
  atmWithdrawalFeeInternational: 1.5,
  atmWithdrawalFee: 1,
  statementReprintFee: 5,
  cashWithdrawalFee: 2,
  maximumPurchase2: 250,
  interestRate: 0,
};

export const defaultAu28DAnnualFee = {
  annualFee: 'Card fee of $96 per year, waived for the first year. See other {{ratesAndFeesLink}} here.',
  feesCharge: {
    left: 'A credit card fee will be charged.',
    right: '$96.00 per year',
  },
};

/* toggle for enabled balance transfer flow. It's product specific and can be channel specific as well. channel value could be true, false and always. For example,
{
  "CCAU28D": false,
  "CCAUDJG": false,
  "CCAUDJM": false,
  "CCAUGEM": true,
  "CCAUGOM": false,
  "CCAULRM": {
    "channels": {
      "APPLY_AND_SHOP": false,
      "DIRECT": "always",
      "EXTERNAL_QR": false,
      "INSTORE": false,
      "ONLINE": true
    }
  },
  "CCNZGEM": false
} 
*/
const defaultBalanceTransfer = {
  [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: false,
  [PRODUCT_CODE_DAVID_JONES_PREMIERE]: false,
  [PRODUCT_CODE_AU_GEM]: false,
  [PRODUCT_CODE_GO]: false,
  [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: false,
  [PRODUCT_CODE_LOW_RATE]: true,
  [PRODUCT_CODE_NZ_GEM]: false,
};

const DEFAULT_SHARED_FEATURES = {
  maintenanceMessage: defaultMaintenanceMessages,
  offerTypeMapping: defaultOfferTypeMapping,
  emailVerificationFallback: true,
  mobileConfirmationModal: true,
  smsEmailVerificationOptions: true,
  defaultPromoCode,
  expensesLibrary: false,
  requestBalanceTransfer: defaultBalanceTransfer,
};
const DEFAULT_SHARED_FEATURES_AU = {
  ...DEFAULT_SHARED_FEATURES,
  auBankStatementOcr: true,
  auDisclaimer: true,
  auOneTap: true,
};

export const DEFAULT_FEATURES_NZ = {
  ...DEFAULT_SHARED_FEATURES,
  nzDmsUpload: false,
  nzGemRatesAndFees: defaultNzRatesAndFees,
  nzGemPromoCode: false,
  nzGemSaveAndResume: false,
  nzGemShowSaveAndResumeButton: false, // for A/B test https://di.latitudefinancial.com/jira/browse/NZP-1565
  nzGemDynamicCreditLimit: false,
  nzGemCreditLimit99999: false,
  nzGemIncomeReplay: false,
  nzGemMaintenancePage: false,
  nzGemEmailVerification: false,
  nzGemBalanceTransfer: true,
  nzGemCreditLimitAcceptance: true,
  nzGemNzUplift: false,
  nzBankStatementOcr: true,
};

export const DEFAULT_FEATURES_DJ = {
  ...DEFAULT_SHARED_FEATURES_AU,
  djSaveAndResume: true,
  djDynamicCreditLimit: true,
  djMaintenancePage: false,
  premiereRatesAndFees: defaultPremiereRatesAndFees,
  prestigeRatesAndFees: defaultPrestigeRatesAndFees,
  auDmsUpload: false,
  djEmailVerification: true,
  djAch: true,
  djBalanceTransfer: true,
  djCampaignBanner: defaultDjCampaignBanner,
  djOfferTitle: true,
  djCvp: true,
  djCvpV2: true,
};

export const DEFAULT_FEATURES_28D = {
  ...DEFAULT_SHARED_FEATURES_AU,
  au28DLaunched: true,
  au28DSaveAndResume: true,
  au28DDynamicCreditLimit: true,
  au28DMaintenancePage: false,
  au28DRatesAndFees: defaultAu28DRatesAndFees,
  auDmsUpload: false,
  au28DEmailVerification: true,
  au28DAch: true,
  au28DBalanceTransfer: true,
  au28DAnnualFee: defaultAu28DAnnualFee,
};

export const DEFAULT_FEATURES_GO = {
  ...DEFAULT_SHARED_FEATURES_AU,
  goLaunched: true,
  goSaveAndResume: true,
  goDynamicCreditLimit: true,
  goMaintenancePage: false,
  goRatesAndFees: defaultGoRatesAndFees,
  auDmsUpload: false,
  goEmailVerification: true,
  goAch: true,
  goBalanceTransfer: true,
};

export const DEFAULT_FEATURES_AU_GEM = {
  ...DEFAULT_SHARED_FEATURES_AU,
  auGemLaunched: true,
  auGemSaveAndResume: true,
  auGemDynamicCreditLimit: true,
  auGemMaintenancePage: false,
  auGemRatesAndFees: defaultAuGemRatesAndFees,
  auDmsUpload: false,
  auGemEmailVerification: true,
  auGemAch: true,
  auGemBalanceTransfer: true,
};

export const DEFAULT_FEATURES_AFS = {
  ...DEFAULT_SHARED_FEATURES_AU,
  afsLaunched: true,
  afsSaveAndResume: true,
  afsDynamicCreditLimit: true,
  afsMaintenancePage: false,
  afsRatesAndFees: defaultAfsRatesAndFees,
  auDmsUpload: false,
  afsEmailVerification: true,
  afsAch: false,
  afsBalanceTransfer: true,
};

export const DEFAULT_FEATURES_LOW_RATE = {
  ...DEFAULT_SHARED_FEATURES_AU,
  lowRateLaunched: true,
  lowRateSaveAndResume: true,
  lowRateDynamicCreditLimit: true,
  lowRateMaintenancePage: false,
  lowRateRatesAndFees: defaultLowRateRatesAndFees,
  auDmsUpload: false,
  lowRateEmailVerification: true,
  lowRateAch: true,
  lowRateBalanceTransfer: true,
};

export const productCodeToDefaultFeatures = {
  [PRODUCT_CODE_NZ_GEM]: DEFAULT_FEATURES_NZ,
  [PRODUCT_DAVID_JONES]: DEFAULT_FEATURES_DJ,
  [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: DEFAULT_FEATURES_DJ,
  [PRODUCT_CODE_DAVID_JONES_PREMIERE]: DEFAULT_FEATURES_DJ,
  [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: DEFAULT_FEATURES_28D,
  [PRODUCT_CODE_GO]: DEFAULT_FEATURES_GO,
  [PRODUCT_CODE_AU_GEM]: DEFAULT_FEATURES_AU_GEM,
  [PRODUCT_CODE_AFS]: DEFAULT_FEATURES_AFS,
  [PRODUCT_CODE_LOW_RATE]: DEFAULT_FEATURES_LOW_RATE,
};
